module.exports = __webpack_public_path__ + "media/applicants/full-service-shopper-square-9739372b.jpg";